import styled, { css } from "styled-components";
import { typography } from "globalConstants";

import AtomH2 from "Components/Atoms/H2";
import AtomPaper from "Components/Atoms/Paper";

export type PropsType = any;

const Wrap = styled(AtomPaper)``;

const Text = styled.div<any>`
   ${typography.other.t8};
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 9px;
   letter-spacing: -0.03em;
   ${({ css }) => css}
`;
const Purple = styled.span`
   color: ${typography.other.color.purple[0]};
   display: inline;
`;

export default function OrganismForm3(props: PropsType) {
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <AtomH2>1-3. 안내 사항</AtomH2>
         <Text
            css={css`
               margin-top: 24px;
            `}>
            <Purple>*</Purple>등록 건수의 기준은 ‘기간’으로 책정됩니다.
         </Text>
         <Text>아래의 경우는 모두 1건으로 처리되며, 이에 해당될 경우 </Text>
         <Text>contact@art-map.co.kr 로 자료를 보내주시면 </Text>
         <Text>진행 도와드리겠습니다. </Text>
         <Text
            css={css`
               margin-top: 22px;
            `}>
            1) 동일 기간 내에 한 전시관에서 2개 이상의 전시가 개최될 경우
         </Text>
         <Text>2) 동일한 기획전시가 여러 전시관에서 동시 개최될 경우</Text>
      </Wrap>
   );
}
